module.exports = __webpack_public_path__ + "static/media/icon-cancelamento.43d88e14.svg";